<script>
  import { pop, link } from "svelte-spa-router";
  import active from "svelte-spa-router/active";

  /**
   * retour arriere (history)
   */
  const back = () => {
    pop();
  };
</script>

<div class="fixed-top navbar-dark bg-dark">
  <ul class="nav  ">
    <li class="nav-item">
      <a
        class="nav-link active"
        aria-current="page"
        href="/"
        use:link
        use:active={{ path: "/", className: "active" }}>Accueil</a
      >
    </li>

    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="/#"
        role="button"
        aria-expanded="false">Personnes</a
      >
      <div class="dropdown-menu">
        <a
          class="nav-link"
          href="/listecard"
          use:link
          use:active={{ path: "/listecard/" }}>liste carte</a
        >
        <a
          class="nav-link"
          href="/mouvt"
          use:link
          use:active={{ path: "/mouvt/" }}>mouvt.</a
        >
        <a
          class="nav-link"
          href="/partis"
          use:link
          use:active={{ path: "/partis/" }}>Partis</a
        >
      </div>
    </li>

    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="/#"
        role="button"
        aria-expanded="false">Infos</a
      >
      <div class="dropdown-menu">
        <a
          class="nav-link"
          href="/salposition"
          use:link
          use:active={{ path: "/salposition/" }}>Position sal.moyen</a
        >
        <a
          class="nav-link"
          href="/salaugment"
          use:link
          use:active={{ path: "/salaugment/" }}>Augementations</a
        >
        <a
          class="nav-link"
          href="/salprimes"
          use:link
          use:active={{ path: "/salprimes/" }}>Primes</a
        >
        <a
          class="nav-link"
          href="/salinfo"
          use:link
          use:active={{ path: "/salinfo/" }}>Masse sal.</a
        >
        <a
          class="nav-link"
          href="/test"
          use:link
          use:active={{ path: "/test/" }}>test</a
        >
      </div>
    </li>
  </ul>
</div>

<style>
  a {
    color: rgb(28, 154, 245);
  }
</style>
